import React from "react";

export default function PageHeader({ title, meta, actions }) {
  return (
    <div>
      <div className="flex items-center justify-between gap-3 min-h-[36px]">
        <h1 className="text-[22px] md:text-[28px] leading-tight font-bold text-ink truncate">{title}</h1>
        {actions && <div className="shrink-0 flex items-center gap-2">{actions}</div>}
      </div>
      {meta && <div className="mt-1 text-meta text-muted">{meta}</div>}
    </div>
  );
}
